import { createAction } from '@reduxjs/toolkit';
import { AuthTokens } from '../services/auth/types';

export const logout = createAction<void>('auth/logout');
export const applyLocallyStoredTokens = createAction<Omit<AuthTokens, 'expires_in'>>('auth/applyLocallyStoredTokens');
export const refreshTokens = createAction<AuthTokens>('auth/refreshTokens');
